import { useRef, useState, useEffect } from 'react';
import { Typography, Tooltip } from '@mui/material';

type EllipsisTypographyProps = {
    title: string;
};

export default function EllipsisTypography({ title }: EllipsisTypographyProps) {
    const textRef = useRef<HTMLSpanElement>(null);
    const [isOverflow, setIsOverflow] = useState(false);

    useEffect(() => {
        const el = textRef.current;
        if (el) {
            setIsOverflow(el.scrollWidth > el.clientWidth);
        }
    }, [title]);

    const content = (
        <Typography
            ref={textRef}
            fontWeight={500}
            sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: 300,
            }}
        >
            {title}
        </Typography>
    );

    return isOverflow ? (
        <Tooltip title={title} placement="top-start">
            {content}
        </Tooltip>
    ) : (
        content
    );
}
